import { ProductCardMediaEnum } from '@inter-ikea-kompis/component-product-card';

enum ProductShelfProductCardMediaEnum {
	singleImage = ProductCardMediaEnum.singleImage,
	switchImageOnHover = ProductCardMediaEnum.switchImageOnHover
}

export default ProductShelfProductCardMediaEnum;
